import { useState } from "react";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import API_BASE_URL from "../config.js";
const ContactSection = () => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        message: "",
        service:"Vrruksh Travels"
    });

    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Mobile validation regex (10 digits, starts with 6-9)
    const mobileRegex = /^[6-9]\d{9}$/;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        debugger
        e.preventDefault();
        setSuccess("");
        setErrorMsg("");
        let validationErrors = {};

        if (!formData.name.trim()) {
            validationErrors.name = "Name is required.";
        }
        if (!emailRegex.test(formData.email)) {
            validationErrors.email = "Enter a valid email address.";
        }
        if (!mobileRegex.test(formData.mobile)) {
            validationErrors.mobile = "Enter a valid 10-digit mobile number.";
        }
        if (!formData.message.trim()) {
            validationErrors.message = "Message is required.";
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const updateform ={
           ...formData,
            service:"Vrruksh Travels"
        }
        try {
            const response = await axios.post(`${API_BASE_URL}/api/contact`, updateform);
            if (response.status === 200) {
                setSuccess(response.data.message);
                setShow(true);
                setFormData({ name: "", email: "", mobile: "", message: "" });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setErrorMsg(error.response?.data?.error || "Something went wrong");
        }
    };
    return (
        <div className="container-fluid pt-5 pb-0">
            <div className="contactSection bg-white ">
                <div className="row">

                    <div className="col-md-6">
                        <div className="leftcontact1">
                            <h4>For any questions about renting, just <span>WRITE TO US</span> </h4>
                            <p>We’ll message you on Email or WhatsApp to discuss your travel needs in details.
                                See you soon ...</p>
                        </div>
                    </div>


                    <div className="col-md-5 offset-md-1">
                        <div className="contactformbg1">
                        {success && <p className="success d-none">{success}</p>}
                        {errorMsg && <p className="error">{errorMsg}</p>}
                            <Form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <Form.Control
                                            size="lg"
                                            type="text"
                                            placeholder="* Your full name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                        {errors.name && <Form.Text className="text-danger">{errors.name}</Form.Text>}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <Form.Control
                                            size="lg"
                                            type="number"
                                            placeholder="*Your mobile number"
                                            name="mobile"
                                            value={formData.mobile}
                                            onChange={handleChange}
                                        />
                                        {errors.mobile && <Form.Text className="text-danger">{errors.mobile}</Form.Text>}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <Form.Control
                                            size="lg"
                                            type="email"
                                            placeholder="*Your email ID"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        {errors.email && <Form.Text className="text-danger">{errors.email}</Form.Text>}
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            placeholder="Additional requests or special instructions"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                        />
                                        {errors.message && <Form.Text className="text-danger">{errors.message}</Form.Text>}
                                    </div>

                                    <div className="col-md-12 mb-3 text-dark">
                                        <Form.Group controlId="formBasicCheckbox" className="d-flex chekmarh">
                                            <Form.Check size="lg" type="checkbox" required />
                                            <span>
                                                By clicking the button, you accept the terms of the
                                                <Link to="/"> Privacy Policy</Link> and the
                                                <Link to="/"> Terms & Conditions</Link>
                                            </span>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12 mb-3 text-dark">
                                        <Button className="w-100 bookcombtn" type="submit">
                                            Submit Booking Enquiry <i className="bi bi-car-front-fill fs-5 ms-2"></i>
                                        </Button>
                                    </div>
                                </div>
                            </Form>



                        </div>
                    </div>

                </div>
            </div>
            <Modal show={show} onHide={handleClose} animation={false} centered>
                <Modal.Body>
                    <div className='text-center p-4'>
                        <h4>Submission Successful !</h4>
                        <p>Thank you for reaching out to us. We will get back to you soon!</p>
                        <Button variant="dark" className='mt-2' onClick={handleClose} style={{ width: "100px" }}>
                            CLOSE
                        </Button>
                    </div>
                </Modal.Body>

            </Modal>
        </div>

    );
}
export default ContactSection;